import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../../generic/formgenerico/formgenerico';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdendoPecasService } from 'src/app/services/adendo/adendo-pecas.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { animate, style, transition, trigger } from '@angular/animations';
import { FormVisualizacaoXmlComponent } from '../formvisualizacaoxml/formvisualizacaoxml.component';

@Component({
    selector: 'app-form-comparacao-ncm',
    templateUrl: './formimpcomparacao.component.html',
    styleUrls: ['../../../generic/formgenerico/formgenerico.component.css'],
})
export class FormComparacaoNcmComponent implements OnInit {

    arquivosSelecionados: File[] = [];
    comparacoes: any[] = [];
    carregando: boolean = false;
    erroUpload: string = '';
    carregandoAtualizacao: boolean = false;
    progressoAtual: number = 0;
    totalArquivos: number = 0;

    // Filtros para a tabela
    filtroNcmDiferente: boolean = false;
    filtroPnNaoEncontrado: boolean = false;

    // Controle de atualização
    itensSelecionadosParaAtualizar: Set<number> = new Set();

    // Controle de expansão da seção de upload
    secaoUploadExpandida: boolean = true;

    // Controle do checkbox master
    checkboxMasterSelecionado: boolean = false;

    constructor(
        private injectorObj: Injector,
        private apiAdendoPecas: AdendoPecasService,
        public refDialog: DynamicDialogRef,
        public configDialog: DynamicDialogConfig,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private dialogService: DialogService
    ) { }

    ngOnInit(): void {
        // Inicialização se necessário
    }

    onFileSelect(event: any) {
        this.arquivosSelecionados = [];
        this.erroUpload = '';

        if (event.files && event.files.length > 0) {
            for (let file of event.files) {
                // Valida se é XML
                if (file.name.toLowerCase().endsWith('.xml')) {
                    this.arquivosSelecionados.push(file);
                } else {
                    this.erroUpload = 'Apenas arquivos XML são permitidos!';
                }
            }
        }
    }

    removerArquivo(index: number) {
        this.arquivosSelecionados.splice(index, 1);
    }

    limparArquivos() {
        this.arquivosSelecionados = [];
        this.comparacoes = [];
        this.erroUpload = '';
    }

    processarXMLs() {
        if (this.arquivosSelecionados.length === 0) {
            this.erroUpload = 'Selecione pelo menos um arquivo XML!';
            return;
        }

        this.carregando = true;
        this.erroUpload = '';
        this.comparacoes = [];
        this.progressoAtual = 0;
        this.totalArquivos = this.arquivosSelecionados.length;

        const formData = new FormData();

        this.arquivosSelecionados.forEach(file => {
            formData.append('files', file);
        });

        this.apiAdendoPecas.compararNcmXml(formData).subscribe({
            next: (response: any[]) => {
                this.progressoAtual = 100;

                this.comparacoes = response.map(item => ({
                    ...item,
                    selecionado: false
                }));

                this.carregando = false;
                this.progressoAtual = 0;

                // Limpa seleções anteriores
                this.itensSelecionadosParaAtualizar.clear();
                this.checkboxMasterSelecionado = false;

                if (this.comparacoes.length > 0) {
                    this.secaoUploadExpandida = false;
                }

                if (this.comparacoes.length === 0) {
                    this.erroUpload = 'Nenhum item encontrado nos XMLs ou erro no processamento.';
                }
            },
            error: (error) => {
                console.error('Erro ao processar XMLs:', error);
                this.erroUpload = 'Erro ao processar XMLs: ' + (error.error?.message || error.message);
                this.carregando = false;
                this.progressoAtual = 0;
            }
        });
    }

    toggleSecaoUpload() {
        this.secaoUploadExpandida = !this.secaoUploadExpandida;
    }

    toggleFiltroNcmDiferente() {
        this.filtroNcmDiferente = !this.filtroNcmDiferente;
        setTimeout(() => this.atualizarCheckboxMaster(), 0);
    }

    toggleFiltroPnNaoEncontrado() {
        this.filtroPnNaoEncontrado = !this.filtroPnNaoEncontrado;
        setTimeout(() => this.atualizarCheckboxMaster(), 0);
    }

    get comparacoesExibidas(): any[] {
        let resultado = this.comparacoes;

        if (this.filtroNcmDiferente) {
            resultado = resultado.filter(c => c.ncmDiferente === true);
        }

        if (this.filtroPnNaoEncontrado) {
            resultado = resultado.filter(c => c.ncmSistema === 'PN NÃO ENCONTRADO');
        }

        return resultado;
    }

    get totalItens(): number {
        return this.comparacoes.length;
    }

    get totalDiferentes(): number {
        return this.comparacoes.filter(c => c.ncmDiferente === true).length;
    }

    get totalNaoEncontrados(): number {
        return this.comparacoes.filter(c => c.ncmSistema === 'PN NÃO ENCONTRADO').length;
    }

    get totalIguais(): number {
        return this.comparacoes.filter(c => c.ncmDiferente === false).length;
    }

    exportarResultado() {
        // Converter para CSV
        if (this.comparacoes.length === 0) return;

        const headers = ['PN', 'NCM XML', 'NCM Sistema', 'Diferente', 'Arquivo', 'Descrição XML'];
        const csvContent = [
            headers.join(';'),
            ...this.comparacoesExibidas.map(item =>
                [
                    item.pn,
                    item.ncmXml,
                    item.ncmSistema,
                    item.ncmDiferente ? 'SIM' : 'NÃO',
                    item.arquivo,
                    item.descricao ? item.descricao.replace(/;/g, ',') : ''
                ].join(';')
            )
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `comparacao_ncm_${new Date().getTime()}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    fechar() {
        this.refDialog.close();
    }

    onFileChange(event: any) {
        this.erroUpload = '';
        const files = event.target.files;

        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                // Valida se é XML
                if (file.name.toLowerCase().endsWith('.xml')) {
                    // Evita duplicatas
                    if (!this.arquivosSelecionados.find(f => f.name === file.name)) {
                        this.arquivosSelecionados.push(file);
                    }
                } else {
                    this.erroUpload = 'Apenas arquivos XML são permitidos!';
                }
            }
        }

        // Limpa o input para permitir selecionar o mesmo arquivo novamente
        event.target.value = '';
    }

    formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    }

    // Atualizar NCM individual
    atualizarNcmIndividual(item: any) {
        this.confirmationService.confirm({
            message: `Deseja realmente atualizar o NCM do PN "${item.pn}" de ${item.ncmSistema} para ${item.ncmXml}?`,
            header: 'Confirmar Atualização',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.carregandoAtualizacao = true;

                this.apiAdendoPecas.atualizarNcm(item.apeId, item.ncmXml).subscribe({
                    next: (response) => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Sucesso',
                            detail: `NCM do PN "${item.pn}" atualizado com sucesso!`
                        });

                        // Atualiza o item na lista
                        item.ncmSistema = item.ncmXml;
                        item.ncmDiferente = false;

                        this.carregandoAtualizacao = false;

                        this.perguntarAtualizarIpi([item]);
                    },
                    error: (error) => {
                        console.error('Erro ao atualizar NCM:', error);
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erro',
                            detail: 'Erro ao atualizar NCM: ' + (error.error?.message || error.message)
                        });
                        this.carregandoAtualizacao = false;
                    }
                });
            }
        });
    }

    // Atualizar todos os NCMs diferentes
    atualizarTodosDiferentes() {
        const itensDiferentes = this.comparacoes.filter(c =>
            c.ncmDiferente === true &&
            c.ncmSistema !== 'PN NÃO ENCONTRADO' &&
            c.apeId != null
        );

        if (itensDiferentes.length === 0) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Não há itens com NCM diferente para atualizar.'
            });
            return;
        }

        this.confirmationService.confirm({
            message: `Deseja realmente atualizar ${itensDiferentes.length} NCM(s) diferentes?`,
            header: 'Confirmar Atualização em Lote',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.executarAtualizacaoEmLote(itensDiferentes);
            }
        });
    }

    // Atualizar apenas os selecionados
    atualizarSelecionados() {
        const itensSelecionados = this.comparacoes.filter(c =>
            this.itensSelecionadosParaAtualizar.has(c.apeId)
        );

        if (itensSelecionados.length === 0) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Nenhum item selecionado para atualizar.'
            });
            return;
        }

        this.confirmationService.confirm({
            message: `Deseja realmente atualizar ${itensSelecionados.length} item(ns) selecionado(s)?`,
            header: 'Confirmar Atualização',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.executarAtualizacaoEmLote(itensSelecionados);
            }
        });
    }

    // Executa a atualização em lote
    executarAtualizacaoEmLote(itens: any[]) {
        this.carregandoAtualizacao = true;

        const atualizacoes = itens.map(item => ({
            apeId: item.apeId,
            ncmId: item.ncmXml,
            pn: item.pn
        }));

        this.apiAdendoPecas.atualizarNcmsEmLote(atualizacoes).subscribe({
            next: (response: any) => {
                // Atualiza os itens na lista
                itens.forEach(item => {
                    item.ncmSistema = item.ncmXml;
                    item.ncmDiferente = false;
                    item.selecionado = false; // ← ADICIONE ESTA LINHA
                });

                // Limpa seleção
                this.itensSelecionadosParaAtualizar.clear();
                this.checkboxMasterSelecionado = false;
                this.carregandoAtualizacao = false;

                this.messageService.add({
                    severity: 'success',
                    summary: 'Atualização Concluída',
                    detail: `${response.sucesso} NCM(s) atualizado(s) com sucesso! ${response.erro > 0 ? response.erro + ' erro(s).' : ''}`
                });

                if (response.erros && response.erros.length > 0) {
                    console.error('Erros na atualização:', response.erros);
                }

                this.perguntarAtualizarIpi(itens);
            },
            error: (error) => {
                console.error('Erro ao atualizar NCMs em lote:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao atualizar NCMs: ' + (error.error?.message || error.message)
                });
                this.carregandoAtualizacao = false;
            }
        });
    }

    // Toggle seleção de item
    toggleSelecao(item: any) {
        if (this.itensSelecionadosParaAtualizar.has(item.apeId)) {
            this.itensSelecionadosParaAtualizar.delete(item.apeId);
            item.selecionado = false;
        } else {
            this.itensSelecionadosParaAtualizar.add(item.apeId);
            item.selecionado = true;
        }

        // Atualiza o estado do checkbox master
        this.atualizarCheckboxMaster();
    }

    // Selecionar/Desselecionar todos diferentes
    toggleTodosDiferentes() {
        const itensDiferentes = this.comparacoesExibidas.filter(c =>
            c.ncmDiferente === true &&
            c.ncmSistema !== 'PN NÃO ENCONTRADO' &&
            c.apeId != null
        );

        const todosSelecionados = itensDiferentes.every(item =>
            this.itensSelecionadosParaAtualizar.has(item.apeId)
        );

        if (todosSelecionados) {
            // Desseleciona todos
            itensDiferentes.forEach(item => {
                this.itensSelecionadosParaAtualizar.delete(item.apeId);
                item.selecionado = false;
            });
            this.checkboxMasterSelecionado = false;
        } else {
            // Seleciona todos
            itensDiferentes.forEach(item => {
                this.itensSelecionadosParaAtualizar.add(item.apeId);
                item.selecionado = true;
            });
            this.checkboxMasterSelecionado = true;
        }
    }

    visualizarTodosXmls() {
        this.dialogService.open(FormVisualizacaoXmlComponent, {
            header: 'Visualização Completa dos XMLs Processados',
            width: '95%',
            height: '90vh',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            data: {
                itens: this.comparacoes
            }
        });
    }

    atualizarCheckboxMaster() {
        const itensDiferentes = this.comparacoesExibidas.filter(c =>
            c.ncmDiferente === true &&
            c.ncmSistema !== 'PN NÃO ENCONTRADO' &&
            c.apeId != null
        );

        if (itensDiferentes.length === 0) {
            this.checkboxMasterSelecionado = false;
            return;
        }

        const todosSelecionados = itensDiferentes.every(item =>
            this.itensSelecionadosParaAtualizar.has(item.apeId)
        );

        this.checkboxMasterSelecionado = todosSelecionados;
    }

    get totalSelecionados(): number {
        return this.itensSelecionadosParaAtualizar.size;
    }

    // ==========================================================
    // Fluxo sequencial: depois de atualizar o(s) NCM(s), oferece
    // atualizar também a alíquota de IPI (fluxo independente, por NCM).
    // ==========================================================
    private perguntarAtualizarIpi(itensAtualizados: any[]) {
        const mapaUnico = new Map<string, any>();

        itensAtualizados.forEach((item: any) => {
            const ncm = item.ncmXml;
            const aliquota = item.aliquotaIpiXml;
            const pn = item.pn;

            if (!ncm || aliquota === null || aliquota === undefined || aliquota === '') {
                return;
            }

            if (!mapaUnico.has(ncm)) {
                mapaUnico.set(ncm, {
                    ncm: ncm,
                    aliquotaIpiXml: aliquota,
                    descricao: item.descricao,
                    arquivo: item.arquivo,
                    pns: []
                });
            }

            // Acumula todos os P/Ns que pertencem a esse NCM (sem duplicar)
            if (pn && !mapaUnico.get(ncm).pns.includes(pn)) {
                mapaUnico.get(ncm).pns.push(pn);
            }
        });

        const itensParaComparar = Array.from(mapaUnico.values());
        if (itensParaComparar.length === 0) {
            return;
        }

        // Compara silenciosamente em segundo plano; só incomoda o usuário se
        // existir algum NCM cadastrado na FISCAL_NCM pra atualizar (iguais ou
        // diferentes -- os iguais também valem a pena reaplicar, pois isso
        // também grava o percentual de IPI direto nos itens).
        this.apiAdendoPecas.compararAliquotaIpi(itensParaComparar).subscribe({
            next: (resultado: any[]) => {
                const atualizaveis = resultado.filter(r => r.ncmEncontrado !== false);

                if (atualizaveis.length === 0) {
                    return;
                }

                const totalDiferentes = atualizaveis.filter(r => r.ipiDiferente === true).length;

                this.confirmationService.confirm({
                    message: totalDiferentes > 0
                        ? `Foram encontrado(s) ${totalDiferentes} NCM(s) com alíquota de IPI diferente da cadastrada (de ${atualizaveis.length} no total). Deseja atualizar agora?`
                        : `A alíquota de IPI já está correta na FISCAL_NCM para ${atualizaveis.length} NCM(s). Deseja reaplicar o NCM/IPI nos itens mesmo assim, para garantir que os campos da peça fiquem atualizados?`,
                    header: 'Atualizar Alíquota de IPI',
                    icon: 'pi pi-question-circle',
                    accept: () => {
                        this.atualizarIpiAutomaticamente(atualizaveis);
                    }
                });
            },
            error: (error) => {
                // Não bloqueia o fluxo principal de NCM caso a checagem de IPI falhe
                console.error('Erro ao verificar alíquota de IPI:', error);
            }
        });
    }

    // Executa a atualização de IPI direto, sem passar pela tela de revisão --
    // mesmo processo (mesmo endpoint em lote) usado pelo botão "Atualizar
    // Todos (Iguais + Diferentes)" da tela de Alíquota de IPI.
    private atualizarIpiAutomaticamente(itens: any[]) {
        const atualizacoes = itens.map(item => ({
            ncmId: item.ncm,
            aliquotaIpi: item.aliquotaIpiNovo,
            pns: item.pns
        }));

        this.apiAdendoPecas.atualizarAliquotaIpiEmLote(atualizacoes).subscribe({
            next: (response: any) => {
                const itensAtualizados = response?.itensAtualizados;
                const houveErro = response.erro > 0;

                this.messageService.add({
                    // Se nada foi atualizado com sucesso, isso é um alerta, não
                    // um "sucesso" -- senão o usuário acha que funcionou.
                    severity: houveErro && response.sucesso === 0 ? 'warn' : 'success',
                    summary: houveErro && response.sucesso === 0
                        ? 'Alíquota de IPI NÃO Atualizada'
                        : 'Alíquota de IPI Atualizada',
                    detail: `${response.sucesso} NCM(s) de IPI atualizado(s) com sucesso!` +
                        (houveErro ? ` ${response.erro} erro(s) -- veja o console (F12).` : '') +
                        (itensAtualizados ? ` NCM/IPI reaplicado em ${itensAtualizados} peça(s) no total.` : ''),
                    sticky: houveErro,
                    life: houveErro ? undefined : 5000
                });

                if (response.erros && response.erros.length > 0) {
                    console.error('Erros na atualização automática de IPI:', response.erros);
                }
            },
            error: (error) => {
                console.error('Erro ao atualizar alíquota de IPI automaticamente:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao atualizar alíquota de IPI: ' + (error.error?.message || error.message)
                });
            }
        });
    }
}
